<footer class="redefine-footer">
    <div class="container">
        <div class="footer-grid">
            <div class="footer-links">
                <h4>Quick Links</h4>
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a (click)="viewAllProperties()">Properties</a></li>
                    <li><a routerLink="/contact">Contact</a></li>
                    <li><a routerLink="/privacy">Privacy Policy</a></li>
                    <li><a routerLink="/terms-and-conditions">Terms & Conditions</a></li>
                </ul>
            </div>

            <div class="footer-contact">
                <h4>Contact</h4>
                <ul>
                    <li>
                        <i class="fa-solid fa-phone"></i>
                        <a href="tel:+27820605355">+27 82 060 5355</a>
                    </li>
                    <li>
                        <i class="fa-solid fa-envelope"></i>
                        <a href="mailto:mark@parkupp.co.za">mark@parkupp.co.za</a>
                    </li>
                    <li>
                        <i class="fa-solid fa-location-dot"></i>
                        <span>Rosebank, Johannesburg</span>
                    </li>
                </ul>
            </div>

            <div class="footer-social">
                <h4>Follow Us</h4>
                <div class="social-links">
                    <a href="https://www.linkedin.com/company/redefine-properties-limited/" target="_blank" rel="noopener">
                        <i class="fa-brands fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.youtube.com/channel/UCk2uAUA0S8Wur_uKEdCefBA" target="_blank" rel="noopener">
                        <i class="fa-brands fa-youtube"></i>
                    </a>
                    <a href="https://www.facebook.com/RedefinePropertiesLimited/" target="_blank" rel="noopener">
                        <i class="fa-brands fa-facebook-f"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <span>© {{ currentYear }} Redefine Properties Limited. All rights reserved.</span>
            <span class="separator">|</span>
            <a routerLink="/about/portal" class="portal-link">ParkUpp portal</a>
        </div>
    </div>
</footer>
